import type { PlaybookEditCard } from '../playbookEdits';

type Props = {
  edits: PlaybookEditCard[];
  onApply: () => void;
  onDismiss: () => void;
};

export default function PlaybookEditCards({ edits, onApply, onDismiss }: Props) {
  if (!edits.length) return null;
  return (
    <div data-testid="playbook-edit-cards" className="shrink-0 border-b border-border px-5 py-3 bg-surface">
      <div className="text-xs font-medium text-textp mb-2">Playbook edits from this score</div>
      <ul className="space-y-1.5 mb-2">
        {edits.map((e, i) => (
          <li key={`${e.skill_id}-${e.content}-${i}`} className="text-[11px] text-textp">
            <span className="font-mono text-texts mr-1">{e.label}</span>
            <span className="text-texts">{e.skill_id}:</span> {e.content}
          </li>
        ))}
      </ul>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onApply}
          className="bg-accent hover:bg-accent-hover text-accent-text text-xs font-medium px-2.5 py-1.5 rounded-md"
        >
          Apply
        </button>
        <button
          type="button"
          onClick={onDismiss}
          className="text-texts hover:text-textp text-xs px-2 py-1.5 rounded-md"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
